import script from "./SeleccionClientes.vue?vue&type=script&setup=true&lang=js"
export * from "./SeleccionClientes.vue?vue&type=script&setup=true&lang=js"

import "./SeleccionClientes.vue?vue&type=style&index=0&id=e6cc163e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6cc163e"]])

export default __exports__